module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.ad12a0fe.png";